import { Checkbox, TableCell, Tooltip } from "@mui/material";

export type DotLegalTableCheckboxCellProps = {
    checked: boolean;
    indeterminate?: boolean;
    disabled?: boolean;
    tooltip?: string;
    onChange: (checked: boolean) => void;
};

// Shared by the header and the rows so the checkboxes line up. Inline padding is used because the table styles override th padding.
function DotLegalTableCheckboxCell(props: DotLegalTableCheckboxCellProps) {
    return (
        <TableCell style={{ padding: 0, width: 42 }} onClick={(event) => event.stopPropagation()}>
            <Tooltip title={props.tooltip ?? ""}>
                <span>
                    <Checkbox
                        color={"primary"}
                        checked={props.checked}
                        indeterminate={props.indeterminate}
                        disabled={props.disabled}
                        onChange={(_, checked) => props.onChange(checked)}
                    />
                </span>
            </Tooltip>
        </TableCell>
    );
}

export default DotLegalTableCheckboxCell;
